var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.750183C0 0.33597 0.335786 0.000183105 0.75 0.000183105H14.25C14.6642 0.000183105 15 0.33597 15 0.750183V4.87764C14.3718 4.91624 13.875 5.40407 13.875 6.00018C13.875 6.5963 14.3718 7.08413 15 7.12272V11.2502C15 11.6644 14.6642 12.0002 14.25 12.0002H0.75C0.335787 12.0002 0 11.6644 0 11.2502V7.12272C0.0265599 7.12435 0.0533547 7.12518 0.0803569 7.12518C0.746057 7.12518 1.28571 6.6215 1.28571 6.00018C1.28571 5.37886 0.746057 4.87518 0.0803569 4.87518C0.0533547 4.87518 0.0265599 4.87601 0 4.87764V0.750183Z",
    fill: "url(#place_icon_coupon_gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1223 3.37784C10.2687 3.52429 10.2687 3.76172 10.1223 3.90817L5.40799 8.62246C5.26154 8.7689 5.0241 8.7689 4.87766 8.62246C4.73121 8.47601 4.73121 8.23857 4.87766 8.09213L9.59194 3.37784C9.73839 3.23139 9.97583 3.23139 10.1223 3.37784Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78584 4.82149C6.0817 4.82149 6.32155 4.58164 6.32155 4.28578C6.32155 3.98991 6.0817 3.75006 5.78584 3.75006C5.48997 3.75006 5.25012 3.98991 5.25012 4.28578C5.25012 4.58164 5.48997 4.82149 5.78584 4.82149ZM9.21441 8.25006C9.51027 8.25006 9.75012 8.01021 9.75012 7.71435C9.75012 7.41848 9.51027 7.17863 9.21441 7.17863C8.91854 7.17863 8.67869 7.41848 8.67869 7.71435C8.67869 8.01021 8.91854 8.25006 9.21441 8.25006ZM5.78584 5.57149C6.49592 5.57149 7.07155 4.99586 7.07155 4.28578C7.07155 3.57569 6.49592 3.00006 5.78584 3.00006C5.07576 3.00006 4.50012 3.57569 4.50012 4.28578C4.50012 4.99586 5.07576 5.57149 5.78584 5.57149ZM9.21441 9.00006C9.92449 9.00006 10.5001 8.42443 10.5001 7.71435C10.5001 7.00427 9.92449 6.42863 9.21441 6.42863C8.50433 6.42863 7.92869 7.00427 7.92869 7.71435C7.92869 8.42443 8.50433 9.00006 9.21441 9.00006Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "place_icon_coupon_gradient",
    x1: 16.6667,
    y1: -1.28553,
    x2: -2.06434,
    y2: 13.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48CEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D480"
  })))));
}
export default SvgCouponIcon;